import clsx from 'clsx';

import { Typography } from '../../typography';

import type { TypographyProps } from '../../typography';

import s from './Suffix.module.css';

type SuffixProps = Omit<TypographyProps<'span'>, 'component' | 'variant'>;

export const Suffix = ({ children, className, color = 'grey-light', ...props }: SuffixProps) => (
  <Typography className={clsx(s.suffix, className)} color={color} component="span" variant="inset-paragraph" {...props}>
    {children}
  </Typography>
);
